import React, { useState, useEffect } from "react";

// ------------ Lib ------------------
import _ from "lodash";

// ------------ Components ------------
import Modal from "react-bootstrap/Modal";
import {
  Row,
  Col,
  Button,
  Form,
  ListGroup,
  Table,
  Toast,
  Pagination,
  InputGroup,
  Video,
  FormControl,
  Spinner,
  ProgressBar,
} from "react-bootstrap";
import Loader from "../Loader/Loader";
import EditIcon from "@material-ui/icons/Edit";
import { Tab, Tabs } from "react-bootstrap";
import { Info, Photo } from "@material-ui/icons";
import { PlayCircleIcon } from "@material-ui/icons";
import VideoVideo from "./image/play.png";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
// -------------- APIs ---------------
import API from "../../network/dashboardAPI";

// -------------- Style --------------
import styled from "styled-components";
import "react-datetime/css/react-datetime.css";
import UploadService from "../../services/FileUploadService";

const HelpPageWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;
const Progress = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 20px;
  z-index: 99;
  width: 400px;
  .pro{
    height: 20px;
    padding: 20px;
  }
`;

const labelStyle = {
  lineHeight: "2rem",
  minWidth: "140px",
};

const logo = {
  height: "50Px",
  width: "70Px",
};

const appPort = window.location.port.toString();
const appProtocol = window.location.protocol.toString();
const appHost = window.location.hostname.toString();
const appUrl = `${appProtocol}//${appHost}:${appPort}`;

const ShopByCatsManagement = (props) => {
  /*
   *   Reference
   * */
  const _VideoInputFile = React.useRef(null);

  /*
   *   =================== States ==========================
   * */
  const [isRequesting, setIsRequesting] = useState(false);
  const [isRequestingUpsert, setIsRequestingUpsert] = useState(false);
  const [isUploadingVideo, setIsUploadingVideo] = useState(false);
  // table states
  const [dataList, setDataList] = useState([]);

  // filter states
  const [selectedStatus, setSelectedStatus] = useState(0);

  // pagination states
  const [next, setNext] = useState(1);
  const [limit, setLimit] = useState(3);
  const [prev, setPrev] = useState(0);
  const [pager, setPager] = useState(1);
  const [dataCount, setDataCount] = useState(0);

  // modal states
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowVideoModal, setIsShowVideoModal] = useState(false);
  const [video_linkToView, setVideo_linkToView] = useState();

  // form states
  const [validated, setValidated] = useState(false);
  const [dataToUpdate, setDataToUpdate] = useState({});
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [video_link, setVideo_link] = useState("");
  const [webLink, setWebLink] = useState("");
  const [dataId, setDataId] = useState("");
  const [dataNumber, setDataNumber] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [formType, setFormType] = useState("ADD");
  const [progress, setProgress] = useState(0);
  // Form validation
  const [formError, setFormError] = useState({
    title: false,
    description: false,
    video_link: false,
  });
  const [webLinkFormatError, setWebLinkFormatError] = useState(false);

  // toast states
  const [toastBgColor, setToastBgColor] = useState("bg-success");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("Delete successful");

  // Taps states
  const [type, setType] = useState(0);

  // confirm
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
  const [dataToUpdateStatus, setDataToUpdateStatus] = useState({});
  const [isRequestingUpdateStatus, setIsRequestingUpdateStatus] =
    useState(false);

  /*
   *   =================== Methods =========================
   * */
  const getHomePageVideoList = async ($next) => {
    setIsRequesting(true);
    let params = { next: $next, limit };
    let body = {
      get_type: selectedStatus
    }
    if (selectedStatus === 1 || selectedStatus === 2) {
      body.is_active = selectedStatus;
    }

    await API.AdminGetAllVideoHomePage(params, body)
      .then((res) => res.json())
      .then((res) => {
        if (!_.isEmpty(res.data)) {
          setDataList(res.data.list);
          setDataCount(res.data.total);

          if (res.data.next) {
            setNext(res.data.next);
          } else if (res.data.list.length) {
            setNext($next > 0 ? next + res.data.list.length : res.data.list.length);
          } else {
            setNext(0);
          }

          setIsRequesting(false);
        } else {
          setIsRequesting(false);
        }
      });
  };

  useEffect(() => {
    getHomePageVideoList(0);
  }, [selectedStatus]);

  const handleOpenModal = (formType, data) => {
    if (formType === "UPDATE") {
      setFormData(data);
      setVideo_link(data.video_link)
      console.log(data.video_link);
    }

    setFormType(formType);
    setIsShowModal(true);
  };

  // modal event
  const handleCloseModal = () => {
    setIsShowModal(false);
    resetFormData();
    resetFormError();
  };

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleDescription = (e) => {
    setDescription(e.target.value);
  };

  const handleUpsertVideo = async () => {
    if (checkFormValidate()) {
      if (dataId) {
        await updateVideoHomePage();
        await UpdateVideoHomePageIsActive();
      } else
        await createVideoHomePage();
    }
  };

  const checkValidateWebLink = () => {
    let linkExpressValidate = webLink.includes(`${appUrl}/express`);
    let linkServer = webLink.includes(`${appUrl}`);
    if (type === 0) {
      setWebLinkFormatError(linkExpressValidate);
      return !linkExpressValidate;
    } else {
      setWebLinkFormatError(linkServer ? !linkExpressValidate : false);
      return linkServer ? linkExpressValidate : true;
    }
  };

  // toast event
  const handleShowToast = (type) => {
    setShowToast(true);

    if (type === "SUCCESS") {
      setToastBgColor("bg-success");
      setToastMessage("Operation successful.");
    } else if (type === "ERROR") {
      setToastBgColor("bg-error");
      setToastMessage("Operation error.");
    }
  };

  // pagination handlers
  const handlePaginNext = () => {
    const { next, prev } = updatePaginationProps("NEXT");
    getHomePageVideoList(prev);
  };

  const handlePaginPrev = () => {
    const { pager, next, prev } = updatePaginationProps("PREV");
    getHomePageVideoList(prev);
  };
  const updatePaginationProps = (type) => {
    let tmpPager = pager + 1;
    if (type === "PREV") {
      tmpPager = pager - 1;
    }

    const tmpNext = limit * tmpPager;
    const tmpPrev = limit * tmpPager - limit;

    setPager(tmpPager);
    setPrev(tmpPrev);

    return { pager: tmpPager, next: tmpNext, prev: tmpPrev };
  };

  const handleFileChange = async (action) => {
    try {
      setIsUploadingVideo(true);
      let formData = null;
      // console.log(_VideoInputFile.current.files[0]);

      if (_VideoInputFile.current !== null && action === "home") {
        formData = new FormData();
        formData.append("video", _VideoInputFile.current.files[0]);

        await UploadService.uploadVideo(formData, (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const totalBytes = progressEvent.total;
          const progress = Math.round((uploadedBytes / totalBytes) * 100);
          setProgress(progress - 25);
        }).then((response) => {
          if (response.data.success) {
            for(let i = 1; i<=25; i++){
              setProgress(75+i)
            }
            // setProgress(100)
            handleShowToast("SUCCESS");
            let VideoLink = response.data.data.url;
            setVideo_link(VideoLink);
          }
          setIsUploadingVideo(false);
        });
      }
    } catch (e) {
      console.log("Debug: ", e);
      handleShowToast("ERROR");
      setIsUploadingVideo(false);
    }
  };

  const createVideoHomePage = async () => {
    setIsRequestingUpsert(true);
    let body = {
      video_link,
      title,
      description,
    };
    try {
      await API.createVideoHomePage(body)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            handleShowToast("SUCCESS");
            getHomePageVideoList(0);
          } else {
            handleShowToast("ERROR");
          }
          // reset paginate
          resetPagination();

          setIsRequestingUpsert(false);
          handleCloseModal();
        });
    } catch (e) {
      console.log(e);
    }
  };

  const updateVideoHomePage = async () => {
    setIsRequestingUpsert(true);
    let body = {
      video_link,
      title,
      description,
    };
    let params = {
      id: dataId
    }
    try {
      await API.UpdateVideoHomePage(params, body)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            handleShowToast("SUCCESS");
            getHomePageVideoList(0);
          } else {
            handleShowToast("ERROR");
          }
          // reset paginate
          resetPagination();

          setIsRequestingUpsert(false);
          handleCloseModal();
        });
    } catch (e) {
      console.log(e);
    }
  };

  const UpdateVideoHomePageIsActive = async () => {
    setIsRequestingUpsert(true);
    let params = {
      id: dataId
    }
    let body = {
      is_active: isActive
    }
    try {
      await API.UpdateVideoHomePageIsActive(params,body)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            handleShowToast("SUCCESS");
            handleCloseConfirmModal();
            getHomePageVideoList(0);
          } else {
            handleShowToast("ERROR");
          }
          // reset paginate
          resetPagination();

          setIsRequestingUpsert(false);
          handleCloseModal();
        });
    } catch (e) {
      console.log(e);
    }
  };
  const setFormData = (video) => {
    setTitle(video.title);
    setDescription(video.description);
    setDataId(video.id);
    setIsActive(video.is_active);
  };
  const resetFormData = () => {
    setTitle('');
    setDescription('');
    setDataId('');
    setIsActive('');
    setVideo_link('');
  };
  const handleShowVideoModal = (url) => {
    setVideo_linkToView(url);
    setIsShowVideoModal(true);
  };

  const handleCloseVideoModal = () => {
    setVideo_linkToView("");
    setIsShowVideoModal(false);
  };

  const resetFormError = () => {
    setFormError({
      title: false,
      description: false,
      video_link: false,
    })
  }
  const handleCloseConfirmModal = () => {
    setIsShowConfirmModal(false);
    setIsRequestingUpdateStatus(false);
    setDataToUpdateStatus({});
  };

  const handleOpenConfirmModal = (data) => {
    setIsShowConfirmModal(true);
    setIsRequestingUpdateStatus(false);
    setDataToUpdateStatus(data);
    setDataId(data.id)
    setIsActive(data.is_active)
  };

  const resetPagination = () => {
    setPager(1);
    setPrev(0);
  }
  const handleChangeStatusFilter = (e) => {
    // reset pagination
    resetPagination();

    setSelectedStatus(e.target.value);
    console.log(selectedStatus);
  }

  const checkFormValidate = () => {
    let tmpFormError = {
      title: false,
      description: false,
      video_link: false,
    }

    if (!title) tmpFormError.title = true;
    if (!description) tmpFormError.description = true;
    if (!video_link) tmpFormError.video_link = true;

    setFormError(tmpFormError);

    return Object.values(tmpFormError).every(el => el === false);
  }

  let pageItems = [
    <Pagination.Item disabled={next <= limit} key={0} onClick={handlePaginPrev}>
      Prev
    </Pagination.Item>,
    <Form.Group key={1} controlId="formGridPagination">
      <InputGroup>
        <InputGroup.Prepend>
          <InputGroup.Text>{`${next} / ${dataCount}`}</InputGroup.Text>
        </InputGroup.Prepend>
      </InputGroup>
    </Form.Group>,
    <Pagination.Item
      disabled={next === dataCount}
      key={2}
      onClick={handlePaginNext}
    >
      Next
    </Pagination.Item>,
  ];
  const PaginationBasic = () => (
    <div className="d-flex justify-content-center">
      <Pagination>{pageItems}</Pagination>
    </div>
  );

  const tableContent = dataList.length ? (
    dataList.map((video, index) => (
      <tr key={index}>
        <td>{video.id}</td>
        <td onClick={() => handleShowVideoModal(video.video_link)}>
          {/* <img src={VideoVideo} style={{ width: "60px",cursor:"pointer" }} /> */}
          <video width="200" height="100" muted >
            <source src={video.video_link} type="video/mp4" />
          </video>
        </td>
        <td>{video.title}</td>
        <td>{video.description}</td>
        <td className="text-center">
          {/* <Button
            variant={video.is_active === 1 ? "success" : "danger"}
            style={{
              width: "12vh",
              border: "none",
              outline: "none",
              boxShadow: "none",
            }}
            onClick={() => handleOpenConfirmModal(video)}
          >
            {video.is_active === 1 ? "Active" : "Inactive"}
          </Button> */}
          <Button variant={video.is_active ? 'success' : 'danger'}
            onClick={() => handleOpenConfirmModal(video)}
          >
            {
              video.is_active ? <VisibilityIcon></VisibilityIcon> : <VisibilityOffIcon></VisibilityOffIcon>
            }
          </Button>
        </td>
        <td className="text-center">
          <Button
            variant="info"
            onClick={() => handleOpenModal("UPDATE", video)}
          >
            <EditIcon></EditIcon>
          </Button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No data
      </td>
    </tr>
  );

  return (
    <HelpPageWrapper>
      {progress > 0 && progress < 100 &&
        <Progress>
          <div>Video Uploading...</div>
          <ProgressBar now={progress} label={`${progress}%`} />
        </Progress>}
      <SettingsFormContent>
        <div>
          <Row className="mb-2">
            <Col sm={9}>
              <Button
                variant="success"
                disabled={isRequesting || isRequestingUpsert}
                onClick={() => handleOpenModal("ADD", null)}
              >
                Add Video
              </Button>
            </Col>

            <Col sm={3} className="d-flex justify-content-end">
              <Form.Label style={labelStyle}>Filter status: </Form.Label>
              &nbsp;&nbsp;
              <Form.Control
                as="select"
                disabled={isRequesting || isRequestingUpsert}
                onChange={(e) => handleChangeStatusFilter(e)}
                value={selectedStatus}
              >
                <option value={0}>All status</option>
                <option value={1}>Active</option>
                <option value={2}>Inactive</option>
              </Form.Control>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              {isRequesting ? (
                <div style={{ position: "fixed", left: "55%", top: "35%" }}>
                  <Loader color="#9cc54b" h="100" />
                </div>
              ) : (
                [
                  <Table striped bordered hover key={1}>
                    <thead>
                      <tr>
                        <th className="text-center">id</th>
                        <th className="text-center">Video</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>{tableContent}</tbody>
                  </Table>,
                  <PaginationBasic key={2}></PaginationBasic>
                ]
              )}
            </Col>
          </Row>
        </div>
      </SettingsFormContent>

      <Modal
        show={isShowModal}
        onHide={handleCloseModal}
        aria-labelledby="contained-modal-title-vcenter"
        size="md"
        animation={false}
        centered
      >
        <Form noValidate validated={validated} autoComplete="false">
          <Modal.Header closeButton>
            <Modal.Title>
              {formType === "ADD" ? "Add" : "Update"} Video
            </Modal.Title>
          </Modal.Header>
          <Modal.Body key="modalBody">
            <Row>
              <Col sm={12}>
                <Form.Group controlId="formTitle">
                  <Form.Label>Title*</Form.Label>
                  <Form.Control
                    type="text"
                    value={title}
                    placeholder="Title"
                    disabled={isRequestingUpsert}
                    isInvalid={formError.title}
                    required
                    onChange={(e) => handleTitleChange(e)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Title is required.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formDescription">
                  <Form.Label>Description*</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    disabled={isRequestingUpsert}
                    value={description}
                    isInvalid={formError.description}
                    onChange={(e) => handleDescription(e)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Description is required.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formVideo">
                  <Form.Label>Video</Form.Label>
                  <Form.File
                    ref={_VideoInputFile}
                    id="custom-file-translate-scss"
                    label={video_link || "Select file"}
                    isInvalid={formError.video_link}
                    accept="video/mp4, video/mpeg"
                    lang="en"
                    className="mb-2"
                    disabled={isRequestingUpsert || isUploadingVideo}
                    onChange={() => handleFileChange("home")}
                  />
                </Form.Group>
                <Form.Group controlId="Video">
                  <VideoLoading>
                    {isUploadingVideo ? (
                      <div
                        style={{
                          minHeight: "220px",
                          minWidth: "220px",
                          position: "relative",
                        }}
                      >
                        <Spinner
                          animation="grow"
                          style={{
                            margin: "0",
                            position: "absolute",
                            top: "40%",
                            left: "40%",
                          }}
                        />
                      </div>
                    ) : !video_link ? (
                      <div
                        style={{
                          minHeight: "200px",
                          minWidth: "200px",
                          background: "#F5F7FA",
                          textAlign: "center",
                        }}
                      >
                        <Photo
                          style={{
                            position: "absolute",
                            top: "47%",
                            left: "47%",
                          }}
                        ></Photo>
                      </div>
                    ) : (
                      <video autoPlay width="470" height="300" controls>
                        <source src={video_link} type="video/mp4" />
                      </video>
                    )}
                  </VideoLoading>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={isRequestingUpsert || isUploadingVideo}
              variant="primary"
              onClick={() => handleUpsertVideo()}
            >
              {isRequestingUpsert ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}

              <span className="pl-2 pr-2">
                {formType === "ADD" ? "Add" : "Update"}
              </span>
            </Button>

            <Button
              disabled={isRequestingUpsert}
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/*
                ================ View Video modal
            */}

      <Modal show={isShowVideoModal} onHide={handleCloseVideoModal}>
        <Modal.Header closeButton>
          <Modal.Title>Video</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <img alt ="Product" src = {video_linkToView} style = {{width: "100%", alignItems : "center"}}/> */}
          <video autoPlay width="470" height="300" controls>
            <source src={video_linkToView} type="video/mp4" />
          </video>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseVideoModal}>
            Close
          </Button>
          {/* <Button variant="danger">
                 Mark out of stock
            </Button> */}
        </Modal.Footer>
      </Modal>

      {/*
                ================ Confirm active / inactive
            */}
      <Modal
        show={isShowConfirmModal}
        animation={false}
        onHide={handleCloseConfirmModal}
        aria-labelledby="contained-modal-title-vcenter"
        size="xs"
        centered
      >
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title className="text-white">Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body key="modalBody" className="text-center">
          <Form.Label>
            Do you want to{" "}
            {dataToUpdateStatus.is_active ? "inactive" : "active"} this video?
          </Form.Label>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="danger" disabled={isRequestingUpdateStatus} onClick={UpdateVideoHomePageIsActive}>
            {isRequestingUpsert ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}

            <span className="pl-2 pr-2">Ok</span>
          </Button>

          <Button
            variant="secondary"
            disabled={isRequestingUpdateStatus}
            onClick={handleCloseConfirmModal}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Toast
        className={toastBgColor}
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        style={{
          position: "fixed",
          top: 70,
          right: 35,
          zIndex: 1041,
          width: "300px",
        }}
      >
        <Toast.Header>
          <strong className="mr-auto m-3">{toastMessage}</strong>
        </Toast.Header>
      </Toast>
    </HelpPageWrapper>
  );
};

// Style
const VideoLoading = styled.div`
  position: relative;

  .hide {
    display: none;
  }
  .isLoading {
    position: absolute;
    background-color: rgb(255, 255, 255, 0.4);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const SettingsFormContent = styled.div`
  margin-bottom: 50px;

  &:last-child {
    margin-bottom: 0;
  }
  .tabProfile {
    border-bottom: 1px solid #ddd !important;
    justify-content: center;

    margin-bottom: 20px;
  }
`;

export default ShopByCatsManagement;
